import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LeaseGeneralInvoiceReceiptForm from './LeaseGeneralInvoiceReceiptForm';

export const LISTING_ROUTE = '/Lease/Management/Lease/GeneralInvoiceReceipt/Listing';

// Adapts the props-based form (mode, rdNo, onClose) to react-router.
const LeaseGeneralInvoiceReceiptFormRoute = ({ mode }) => {
    const { rdNo } = useParams();
    const navigate = useNavigate();
    // The list refetches on mount, so `saved` only needs to be signalled through router state.
    return (
        <LeaseGeneralInvoiceReceiptForm
            key={`${mode}-${rdNo || 'new'}`}
            mode={mode}
            rdNo={rdNo}
            onClose={(saved) => navigate(LISTING_ROUTE, { state: { refresh: saved ? Date.now() : undefined } })}
        />
    );
};

export default LeaseGeneralInvoiceReceiptFormRoute;
